import React, { useState } from "react";
import {
  Box,
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Sidebar from "./Sidebar";
import Appbar from "./Appbar";
import { Outlet } from "react-router-dom";

const HelpcenterLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Toggle sidebar for mobile
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <Appbar onMenuClick={handleDrawerToggle} />

      <Box display="flex">
        {/* Sidebar */}
        <Sidebar
          isMobile={isMobile}
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
        />
        {/* Main Content */}
        <Box component="main" sx={{ flexGrow: 1, p: 2 }}>
          <Toolbar /> 
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default HelpcenterLayout;
